// Lib Helper
import i18n from '../../lib/reacti18n';

// Content toggle Label
const labels = {
  desktop: {
    personal: i18n.message('smarthelp/contentToggle.content.label.desktop.personal'),
    business: i18n.message('smarthelp/contentToggle.content.label.desktop.business'),
    technical: i18n.message('smarthelp/contentToggle.content.label.desktop.technical'),
  },
  mobile: {
    personal: i18n.message('smarthelp/contentToggle.content.label.mobile.personal'),
    business: i18n.message('smarthelp/contentToggle.content.label.mobile.business'),
    technical: i18n.message('smarthelp/contentToggle.content.label.mobile.technical'),
  },
  alternative: {
    title: i18n.message('smarthelp/contentToggle.content.alterLabel.heading'),
    personal: i18n.message('smarthelp/contentToggle.content.alterLabel.personal'),
    business: i18n.message('smarthelp/contentToggle.content.alterLabel.business'),
    technical: i18n.message('smarthelp/contentToggle.content.alterLabel.technical'),
  },
};

module.exports = {
  labels,
};
